<template>
   <v-row>
    <v-col cols="12">
      <v-card class="px-0">
        <v-skeleton-loader v-if="$store.state.purchases.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{ name: 'BillersBuiltInSettings' }" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>
            Compras
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="purchase" class="mr-1" />
              <!--
                Vuetify 2 no emite eventos de puntero en un v-btn disabled, así que
                el activator del tooltip tiene que ser un contenedor habilitado.
              -->
              <v-tooltip bottom :disabled="!exportBlocked" max-width="320">
                <template v-slot:activator="{on}">
                  <div v-on="on" style="display:inline-block">
                    <v-menu close-on-click close-on-content-click  :disabled="exportBlocked" left :nudge-bottom="10" offset-y transition="slide-y-transition">
                      <template v-slot:activator="{on: menu}">
                        <v-btn class="ml-1" :disabled="exportBlocked" :loading="$store.state.exports.createLoader" outlined color="secondary" v-on="menu">
                          Exportar
                          <v-icon small right>mdi-chevron-down</v-icon>
                        </v-btn>
                      </template>
                      <v-list class="text-right" dense>
                        <v-list-item @click="createExport('purchase_data', 'csv')">
                          <v-list-item-title>Datos en .csv</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="createExport('purchase_data', 'xlsx')">
                          <v-list-item-title>Datos en .xlsx</v-list-item-title>
                        </v-list-item>
                        <v-divider />
                        <v-list-item @click="createExport('purchase_xml')">
                          <v-list-item-title>Archivos en .xml</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
                <span>{{exportBlockedMessage}}</span>
              </v-tooltip>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <purchase-list :show-select-row="true" :selected="selected" @update:selected="selected = $event" />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import PurchaseList from '@/components/purchase/PurchaseList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'

// Debe coincidir con EXPORT_MAX_ROWS en piriod-api (exports/models.py). El bloqueo
// acá es solo UX: el servidor vuelve a validarlo.
const EXPORT_MAX_ROWS = 1000

export default {
  components: {
    PurchaseList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    selected: [],
    filters: [
      {
        type: 'text',
        id: 'supplier__name',
        label: 'Proveedor',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'date',
        label: 'Fecha',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'total',
        label: 'Total',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'numeric',
        id: 'number',
        label: 'Número',
        operators: ['es igual', 'es menor a', 'es mayor a']
      }
    ]
  }),
  computed: {
    ...mapState({
      count: state => state.purchases.purchasesCount
    }),
    // Sin selección se exporta todo lo que devuelven los filtros; con selección,
    // solo lo seleccionado.
    exportCount () {
      return this.selected.length || this.count || 0
    },
    exportBlocked () {
      return !this.exportCount || this.exportCount > EXPORT_MAX_ROWS
    },
    exportBlockedMessage () {
      if (!this.exportCount) {
        return 'No hay registros para exportar.'
      }
      return `Estás intentando exportar ${this.exportCount} registros y el máximo es ${EXPORT_MAX_ROWS}. Filtra por fecha o proveedor, o selecciona las compras que necesitas.`
    }
  },
  methods: {
    getList () {
      this.selected = []
      this.$store.dispatch('purchases/LIST', {
        resource: 'purchases',
        query: this.$route.query
      })
    },
    createExport (type, extension = 'csv') {
      /**
       * Los filtros viajan en el QUERYSTRING, no en el body: django-url-filter
       * arma su filterset desde request.query_params y descarta cualquier cosa
       * que venga en el body, sin error. Ver exports/views.py en piriod-api.
       */
      const payload = { type, extension }

      if (this.selected.length) {
        payload.purchases = this.selected.map(d => d.id)
      }

      this.$store.dispatch('exports/CREATE', {
        resource: 'exports/purchases',
        payload,
        query: this.$route.query,
        // El último segmento del resource es 'purchases' y colisionaría con el
        // listado de compras en el store.
        commitInstance: false
      })
      .then(() => {
        this.selected = []
        this.$dialog.message.info('Estamos preparando tu exportación. Te avisaremos por email y quedará disponible en Descargas.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  }
}
</script>
